/* eslint-disable no-bitwise */
/* istanbul ignore file */
import _ from 'underscore';
import $ from 'jquery';
import Promise from 'bluebird';
import { http } from '@bingads-webui/http-util';
import { queryify } from '@bingads-webui/url-util';
import { getEditorialTemplates, ENTITY } from '@bingads-webui-campaign/delivery-status-popup-factory';
import * as editorialRejection from '@bingads-webui-component-legacy/api-errors-campaign/map/editorialRejectionFwdLinkId';

export function getReasonTemplates({
  deliveryStatus, scope, errI18n, locationI18n,
  i18n, commonI18n, permissions, entity, extension,
}) {
  return new Promise((resolve) => {
    let url = '/campaign/AdExtensions.m/GetRejectionReasonData';
    const args = _.extend({
      aid: scope.aid,
      cid: scope.cid,
      cmpid: scope.campaignId,
      type: 'disclaimer',
      adExtensionId: extension.Id,
      campaignId: scope.campaignId || entity.Id,
      version: extension.Version,
    });
    url = queryify(url, args);
    return http.post({
      url,
      data: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
      contentType: 'application/x-www-form-urlencoded',
    }).then(({
      RejectionReasons,
      IsAppealable,
    }) => {
      const reasonTemplates = getEditorialTemplates({
        reasons: _.map(RejectionReasons, Reason => ({
          ReasonCode: Reason.ReasonCode,
          Location: Reason.Location,
          LanguageToCountries: [{
            PublisherCountries: Reason.RejectionCountries,
          }],
        })),
        editorialRejection,
        errI18n,
        i18n,
        locationI18n,
        commonI18n,
        entity: ENTITY.EXTENSION,
        deliveryStatus,
        permissions,
        isAppealable: IsAppealable,
      });
      resolve(reasonTemplates);
    });
  });
}
